import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { User } from "../../models/user.model";

@Component({
  selector: "common-account-support",
  templateUrl: "./account-support.component.html",
  styles: [
    `
      .icon-container {
        font-size: 2em;
      }
    `,
  ],
})
export class AccountSupportComponent implements OnInit, OnChanges {
  @Input() accountSupportUser: User;
  @Input() headerText: string = "Help is always here, whenever you need it.";
  @Input() complementaryText: string = "We’re here to help you every step of the way. Email us or call directly to speak with an account manager.";
  @Input() customEmailSubject: string = "";

  currentEmail: string;
  currentPhone: string;

  constructor() {}

  ngOnInit() {
    this.setEmail();
    this.setPhone();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.accountSupportUser && !changes.accountSupportUser.firstChange) {
      this.setEmail();
      this.setPhone();
    }
  }

  setEmail() {
    this.currentEmail = this.accountSupportUser ? this.accountSupportUser.email : "support@rubbl.com";
  }

  setPhone() {
    this.currentPhone = this.accountSupportUser ? this.accountSupportUser.phone : "(866) 455-8531";
  }

  emailSupport() {
    window.location.href = `mailto:${this.currentEmail}?subject=${this.customEmailSubject}&body=`;
  }

  callSupport() {
    window.location.href = `tel:${this.currentPhone}`;
  }
}
